import { FormControl } from '@angular/forms';
import { SearchServiceCentersResponse } from '../../core/openapi/bff-admin-api';

export interface IServiceCentersFilterForm {
  keyword: FormControl<string>;
}

export type ServiceCenterItem = SearchServiceCentersResponse;

export enum ServiceCenterModalAction {
  Create = 'create',
  Edit = 'edit',
}

export interface IServiceCenterModalData {
  action: ServiceCenterModalAction;
  serviceCenter?: ServiceCenterItem;
}

export interface IServiceCenterForm {
  name: FormControl<string>;
  address: FormControl<string>;
  contactInfo: FormControl<string>;
}
